<template>
  <div v-if="loading === false && this.prize">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')" style="background-color:#FAFAFA;min-height:100vh;">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="back"/>
      <main>
        <b-row>
          <b-col style="margin-top:34px;margin-bottom:34px;text-align:center;">
          <img :src="getPrizeImagePath() + prize.photos[0].id" style="max-width:204px;max-height:204px;min-width:100px;min-height:100px;"/>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col cols="11" style="border: 1px solid #D9D9D9;height:2px;"></b-col>
        </b-row>
        <b-row align-h="center" style="margin-top:32px;">
          <b-col cols="11" style="
            font-style: normal;
            font-weight: normal;
            line-height: 28px;
            font-size: 24px;
            letter-spacing: 0.15px;
          " :style="{color:getCssColor('primary_bt')}">
            {{prize.price_points}} pontos
          </b-col>
        </b-row>
        <b-row align-h="center" style="margin-top:18px;">
          <b-col cols="11" style="
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          font-size: 17px;
          letter-spacing: 0.15px;
          color: #424242;
          ">{{prize.name}}</b-col>
        </b-row>

        <b-row v-if="prize.description" align-h="center" style="margin-top:18px;">
          <b-col cols="11" style="
          font-style: normal;
          font-weight: 500;
          line-height: 20px;
          font-size: 17px;
          letter-spacing: 0.15px;
          color: #121C2A;
          ">Detalhes</b-col>
        </b-row>
        <b-row v-if="prize.description" align-h="center" style="margin-top:18px;">
          <b-col cols="11" style="
          font-style: normal;
          font-weight: normal;
          line-height: 20px;
          font-size: 14px;
          letter-spacing: 0.25px;
          color: #525962;
          padding-bottom:100px;
          " v-html="prize.description">
          </b-col>
        </b-row>
      </main>
      <footer style="position:relative;">
        <!-- fixed button action -->
        <b-row style="position:fixed;bottom:0px;width:100%;height:90px;background-color:#FFFFFF;">
          <div
          @click="addToPrizeCart()"
          :style="{backgroundColor: getCssColor('primary_bt')}"
          style="
          margin:21px auto;
            width:calc( 100% - 64px);height:48px;
            line-height:48px;
            border-radius:4px;
            text-align:center;
            font-style: normal;
            font-weight: 600;
            font-size: 15px;
            text-transform: uppercase;
            color: #FFFFFF;">TROCAR PONTOS</div>
        </b-row>
      </footer>
      <div v-if="successModal" style="width:100vw; height:100vh; position:fixed; background-color:rgb(0,0,0,0.3);top:0px;left:0px;">
        <div style="background-color:#ffffff;border-radius:4px;width:280px;height:340px;margin:100px auto;">
          <b-container>
            <b-row>
              <b-col style="text-align:center;">
                <font-awesome-icon style="font-size:48px;color:#525962;margin-top:20px;" :icon="['fal', 'gifts']"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div style="margin:20px;
                font-style: normal;
                font-weight: 500;
                line-height: 20px;
                font-size: 17px;
                text-align: center;
                letter-spacing: 0.15px;

                color: #424242;
                ">Produto adicionado ao resgate.</div>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div style="
                font-style: normal;
                font-weight: normal;
                line-height: 20px;
                font-size: 14px;
                text-align: center;
                letter-spacing: 0.25px;
                color: #525962;
                ">{{prize.name}}</div>
                </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  @click="finishClaim()"
                  :style="{backgroundColor: getCssColor('primary_bt')}"
                  style="
                  margin:40px auto 0 auto;
                    width:calc( 100% - 24px);height:48px;
                    line-height:48px;
                    border-radius:4px;
                    text-align:center;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 15px;
                    text-transform: uppercase;
                    color: #FFFFFF;">CONCLUIR RESGATE</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div
                  @click="continuePrizes()"
                  :style="{color: getCssColor('primary_bt')}"
                  style="
                  margin:10px auto;
                    width:calc( 100% - 24px);height:24px;
                    line-height:48px;
                    border-radius:4px;
                    text-align:center;
                    font-style: normal;
                    font-weight: 600;
                    font-size: 15px;
                    text-transform: uppercase;
                    ">CONTINUAR RESGATANDO</div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

    </b-container>
  </div>
  <div v-else>
    <InnerLoading/>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import MembershipConn from '@/connection/membership'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import membershipMixin from '@/mixins/membershipMixin'
import { EventBus } from '@/behaviours/event-bus'

export default {
  data () {
    return {
      prize: null,
      loading: true,
      successModal: false
    }
  },

  mixins: [colors, formaters, membershipMixin],
  components: {InnerLoading, HeaderBackMobile},

  async created () {
    this.getPrizeById()
  },

  methods: {
    async getPrizeById () {
      let result = await MembershipConn.getPrizeById(this.$route.params.prize_id)
      if (!result.error) {
        this.prize = result
      }
      this.loading = false
    },

    async addToPrizeCart () {
      this.$store.state.showLoading = true
      let result = await MembershipConn.addPrizeToCart(this.prize.id)
      if (result.error) {
        this.$store.state.showLoading = false
        EventBus.$emit('showAlert', 'error', result.msg)
      } else {
        this.$store.state.showLoading = false
        this.openModalSuccess()
      }
    },

    openModalSuccess () {
      this.successModal = true
    },

    finishClaim () {
      this.$router.push({path:'/membership_address'})
    },

    continuePrizes () {
      this.$router.push({path: '/membership_prizes'})
    }
  }
}
</script>

<style>

</style>
